import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getPartnerById, searchCandidateInTP, updateAttendance, updateQRCandidatePunchOut } from "lib/axiosUtils";
import ShowToast from 'components/ShowToast';
import { TYPE_INFO, INTERVAL, TYPE_FAIL } from 'assets/constants/Constants';
import { PUNCH_IN, PUNCH_OUT, LOADING_SPIN_SMALL } from "assets/constants/Icons";
import './partner.css';
import Spinner from 'components/Spinner';
const moment = require("moment");

const QrAttendancePage = () => {
    const { partnerId } = useParams();
    const [tpDetails, setTpDetails] = useState(null);
    const [formData, setFormData] = useState({});
    const [showForm, setShowForm] = useState(false);
    const [showConfirmTable, setShowConfirmTable] = useState(false);
    const [candidateData, setCandidateData] = useState(null);
    const [showAttendaceTable, setAttendanceTable] = useState(false);
    const [showLoadingPage, setshowLoadingPage] = useState(false);
    const [fetchCandidateLoading, setFetchCandidateLoading] = useState(false);
    const [markAttendanceMsg, setMarkAttendanceMsg] = useState(false);
    const [showNotInclass, setShowNotInclass] = useState(false);
    const [completeAttendaceLoading, setCompleteAttendanceLoading] = useState(false);
    const [showPunchOutOption, setShowPunchOutOption] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const todayDate = new Date();
    const formattedDate = `${String(todayDate.getDate()).padStart(2, '0')}/${String(todayDate.getMonth() + 1).padStart(2, '0')}/${todayDate.getFullYear()}`;

    useEffect(() => {
        const fetchTPDetails = async () => {
            setshowLoadingPage(true);
            try {
                const response = await getPartnerById({}, {}, partnerId);

                if (!response || !response.data || !response.data.result) {
                    ShowToast("Invalid response received from the server", TYPE_FAIL, INTERVAL, "", "");
                    setshowLoadingPage(false);
                    return;
                }

                if (!navigator.geolocation) {
                    ShowToast("Geolocation is not supported by your browser", TYPE_FAIL, INTERVAL, "", "");
                    setshowLoadingPage(false);
                    return;
                }

                navigator.geolocation.getCurrentPosition(
                    async (position) => {
                        try {
                            const { latitude: userLat, longitude: userLng } = position.coords;
                            const tpLat = response?.data?.result?.latitude;
                            const tpLng = response?.data?.result?.longitude;

                            if (tpLat == null || tpLng == null) {
                                ShowToast("Training Partner location not available.", TYPE_FAIL, INTERVAL, "", "");
                                setshowLoadingPage(false);
                                return;
                            }

                            const distance = getDistanceInMeters(userLat, userLng, tpLat, tpLng);
                            if (distance > 100) {
                                setshowLoadingPage(false);
                                setShowNotInclass(true);
                            } else {
                                setshowLoadingPage(false);
                                setTpDetails(response.data.result);
                                setShowForm(true);
                            }
                        } catch (error) {
                            console.error("Error processing location data:", error);
                            ShowToast("Something went wrong while verifying your location.", TYPE_FAIL, INTERVAL, "", "");
                            setshowLoadingPage(false);
                        }
                    },
                    (error) => {
                        console.error("Error accessing location:", error);

                        let message = "Unable to access your location.";
                        if (error.code === 1) {
                            message = "Location permission denied. Please allow location access.";
                        } else if (error.code === 2) {
                            message = "Location unavailable. Please check your GPS or Internet.";
                        } else if (error.code === 3) {
                            message = "Location request timed out. Please try again.";
                        }

                        ShowToast(message, TYPE_INFO, INTERVAL, "", "");
                        setshowLoadingPage(false);
                    },
                    {
                        enableHighAccuracy: true,
                        timeout: 10000, // 10 seconds
                        maximumAge: 0
                    }
                );
            } catch (error) {
                setshowLoadingPage(false);
                ShowToast("Something went wrong", TYPE_FAIL, INTERVAL, "", "");
            }
        };

        fetchTPDetails();
    }, [partnerId]);

    function getDistanceInMeters(lat1, lon1, lat2, lon2) {
        const R = 6371e3; // meters
        const φ1 = lat1 * Math.PI / 180;
        const φ2 = lat2 * Math.PI / 180;
        const Δφ = (lat2 - lat1) * Math.PI / 180;
        const Δλ = (lon2 - lon1) * Math.PI / 180;

        const a = Math.sin(Δφ / 2) ** 2 +
            Math.cos(φ1) * Math.cos(φ2) *
            Math.sin(Δλ / 2) ** 2;
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return R * c;
    }

    const handleInputChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleCandidateSearch = async (e) => {
        e.preventDefault();
        setFetchCandidateLoading(true);

        // Validation for OR condition
        if ((!formData.mobile && !formData.aadhar) && (!formData.firstname || !formData.lastname)) {
            ShowToast(
                "Please enter Mobile or Aadhar, or both First and Last Name to search",
                TYPE_INFO,
                INTERVAL,
                "",
                ""
            );
            setShowConfirmTable(false);
            setFetchCandidateLoading(false);
            setAttendanceTable(false);
            return;
        }

        try {
            const searchParams = {
                firstName: formData.firstname,
                lastName: formData.lastname,
                mobile: formData.mobile,
                aadhar: formData.aadhar,
                date: new Date(),
                partnerId: partnerId
            };

            const response = await searchCandidateInTP({}, searchParams);
            if (response.statusCode === 200) {
                if (response.data.result) {
                    setCandidateData(response.data.result);
                    setShowConfirmTable(true);
                    setFetchCandidateLoading(false);
                    if (response.data.result.attendanceStatus === "already marked") {
                        setShowForm(true);
                        setAttendanceTable(true);
                        setMarkAttendanceMsg(false);
                        setCompleteAttendanceLoading(false);

                        if (response.data.result.dayData.in_time !== "") {
                            const inTime = moment(response.data.result.dayData.in_time, "HH:mm:ss");
                            const currentTime = moment(new Date().toLocaleTimeString('en-GB', { hour12: false }), "HH:mm:ss");
                            const diffInMinutes = currentTime.diff(inTime, 'minutes');

                            if (diffInMinutes > 15) {
                                setShowPunchOutOption(true);
                            }
                        }
                    }
                } else {
                    ShowToast("No Candidate Found, Please Check Again", TYPE_INFO, INTERVAL, "", "");
                    setShowConfirmTable(false);
                    setFetchCandidateLoading(false);
                }
            } else {
                ShowToast("Something went wrong", TYPE_FAIL, INTERVAL, "", "");
                setFetchCandidateLoading(false);
            }
        } catch (error) {
            console.log("Error Occurred while fetching candidate Data:", error);
            setFetchCandidateLoading(false);
        }
    };

    const handleMarkAttendance = async () => {
        try {
            setIsLoading(true);
            if (!candidateData?.candidate?._id || !candidateData?.programDetails?._id || !candidateData?.programDetails?.training_start_date) {
                ShowToast("Missing required data to mark attendance", TYPE_FAIL, INTERVAL, "", "");
                return;
            }

            if (candidateData?.attendanceStatus === "already marked") {
                setShowForm(false);
                setShowConfirmTable(false);
                setAttendanceTable(true);
                setMarkAttendanceMsg(false);
                setIsLoading(false);
                return;
            }
            const traningStartDate = await getTraningStartDate(candidateData.candidate, candidateData.programDetails.partner_batch_data);

            if (!traningStartDate) {
                ShowToast("Cannot update attendance: Missing date", TYPE_FAIL, INTERVAL, "", "");
                return;
            }

            const updateAttendanceParams = {
                candidateId: candidateData.candidate._id,
                programId: candidateData.programDetails._id,
                trainingStartDate: traningStartDate,
                date: new Date(),
                inTime: new Date().toLocaleTimeString('en-GB', { hour12: false }),
                outTime: "",
                batch: candidateData.candidate.batch,
                partnerId: candidateData.candidate.partner_id
            };

            const response = await updateAttendance({}, updateAttendanceParams, candidateData?.candidate._id);

            if (!response || response.statusCode !== 200 || !response.data?.result) {
                ShowToast("Failed to mark attendance. Please try again.", TYPE_FAIL, INTERVAL, "", "");
                return;
            }

            setCandidateData({ ...candidateData, attendanceStatus: 'already marked' });
            setShowConfirmTable(false);
            setShowForm(false);
            setAttendanceTable(true);
            setMarkAttendanceMsg(true);
            setIsLoading(false);
        } catch (err) {
            console.error("Error marking attendance:", err);
            ShowToast("An error occurred while marking attendance. Please try again.", TYPE_FAIL, INTERVAL, "", "");
        }
    };

    const getTraningStartDate = (candidateData, partner_batch_data) => {
        const partner = partner_batch_data.find(
            (p) => p.partner_id === partnerId
        );

        if (!partner) return null;

        const batch = partner.training_batches.find(
            (b) => b.batch === candidateData.batch
        );

        return batch ? batch.start_training_date : null;
    };

    const handleCompleteAttendance = async () => {
        try {
            setCompleteAttendanceLoading(true);
            const updateAttendanceParams = {
                candidateId: candidateData.candidate._id,
                programId: candidateData.programDetails._id,
                outTime: new Date().toLocaleTimeString('en-GB', { hour12: false }),
                date: candidateData.dayData.date,
                batch: candidateData.candidate.batch,
                partnerId: candidateData.candidate.partner_id
            };

            const response = await updateQRCandidatePunchOut({}, updateAttendanceParams);

            if (!response || response.statusCode !== 200 || !response.data?.result) {
                ShowToast("Failed to complete attendance. Please try again.", TYPE_FAIL, INTERVAL, "", "");
                setCompleteAttendanceLoading(false);
                return;
            }

            ShowToast("Attendance completed successfully!", TYPE_INFO, INTERVAL, "", "");

            setShowConfirmTable(false);
            setShowForm(false);
            setAttendanceTable(true);
            setMarkAttendanceMsg(true);
            setCompleteAttendanceLoading(false);
        } catch (err) {
            console.error("Error completing attendance:", err);
            ShowToast("An error occurred while completing attendance. Please try again.", TYPE_FAIL, INTERVAL, "", "");
            setCompleteAttendanceLoading(false);
        }
    };

    return (
        <div className="main-content">
            <div className="scrollable-container">
                <div className="attendance-view">
                    <div className="attendance-div border">
                        <div className="attendance-heading">
                            <h2>Candidate Attendance</h2>
                        </div>
                        <hr />
                        {showLoadingPage ? (
                            <Spinner />
                        ) : (
                            <>
                                {
                                    showForm && (
                                        <>
                                            <div className="tp-info-box mb-4">
                                                <p><strong>Training Partner:</strong> {tpDetails.training_partner}</p>
                                                <p><strong>Representative:</strong> {tpDetails.representative_name}</p>
                                                <p><strong>Address:</strong> {tpDetails.city}, {tpDetails.state} - {tpDetails.pin_code}</p>
                                            </div>

                                            <form>
                                                <div className="row mb-4">
                                                    <div className="col-md-6 mt-3">
                                                        <label className="form-label">Mobile</label>
                                                        <input
                                                            name="mobile"
                                                            type="number"
                                                            className="form-control textbox-height"
                                                            placeholder="Enter Mobile Number"
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                    <div className="col-12 text-center or-div-center">
                                                        <label>-----------OR----------</label>
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label className="form-label">Aadhar Number</label>
                                                        <input
                                                            name="aadhar"
                                                            type="number"
                                                            className="form-control textbox-height"
                                                            placeholder="Enter Aadhar Number"
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                    <div className="col-12 text-center or-div-center">
                                                        <label>-----------OR----------</label>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="form-label">First Name</label>
                                                        <input name="firstname" className="form-control textbox-height" placeholder="First Name" onChange={handleInputChange} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="form-label">Last Name</label>
                                                        <input name="lastname" className="form-control textbox-height" placeholder="Last Name" onChange={handleInputChange} />
                                                    </div>
                                                </div>

                                                <div className="form-button-div mt-4 mb-3">
                                                    <button type="button" className="brand-button width-auto" onClick={handleCandidateSearch} disabled={fetchCandidateLoading} >
                                                        Fetch Candidate Details
                                                    </button>
                                                </div>
                                            </form>
                                            <hr />
                                        </>
                                    )
                                }
                                {
                                    fetchCandidateLoading ? (
                                        <Spinner />
                                    ) : (
                                        showConfirmTable && candidateData && (
                                            <>
                                                <div className="tp-info-box mt-4 mb-3">
                                                    <h5 className="please-cofirm"><strong>{candidateData?.attendanceStatus === "already marked" ? "Candidate Details" : "Confirm and Mark Attendance"}</strong></h5>
                                                    <p><strong>Candidate Name:</strong> {candidateData.candidate.first_name} {candidateData.candidate?.fathers_name} {candidateData.candidate.last_name}</p>
                                                    <p><strong>Project Name:</strong> {candidateData.programDetails?.program_name || 'N/A'}</p>
                                                    <p><strong>Date:</strong> {formattedDate}</p>
                                                </div>
                                                {
                                                    isLoading ? (
                                                        <div className="form-button-div mb-4">
                                                            <i className={LOADING_SPIN_SMALL}></i>
                                                        </div>
                                                    ) : (
                                                        candidateData?.attendanceStatus !== "already marked" && (
                                                            <>
                                                                <div className="form-button-div mb-4">
                                                                    <button className="btn btn-success font-size-btn" onClick={handleMarkAttendance}>
                                                                        <i className={PUNCH_IN} />  Punch In
                                                                    </button>
                                                                </div>
                                                                <hr />
                                                            </>
                                                        )
                                                    )
                                                }
                                            </>
                                        )
                                    )
                                }
                                {
                                    candidateData?.attendanceStatus === "already marked" && showAttendaceTable && (
                                        <div className="text-center mt-4">
                                            {
                                                !candidateData?.dayData?.in_time && (
                                                    <div className="success-checkmark-wrapper mb-3">
                                                        <div className="success-checkmark">
                                                            <div className="check-icon">
                                                                <span className="icon-line line-tip"></span>
                                                                <span className="icon-line line-long"></span>
                                                                <div className="icon-circle"></div>
                                                                <div className="icon-fix"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            {
                                                markAttendanceMsg ? (
                                                    <h5 className="text-success fw-bold">Attendance marked successfully!</h5>
                                                ) : (
                                                    !candidateData?.dayData?.out_time ? (
                                                        completeAttendaceLoading ? (
                                                            <Spinner />
                                                        ) : (
                                                            showPunchOutOption ? (
                                                                <button className="btn btn-success font-size-btn" onClick={handleCompleteAttendance}>
                                                                    Punch Out  <i className={PUNCH_OUT} />
                                                                </button>
                                                            ) : (
                                                                <h5 className="text-success fw-bold mt-4">Attendance already punched in for today!</h5>
                                                            )
                                                        )
                                                    ) : (
                                                        <h5 className="text-success fw-bold mt-4">Attendance already marked for today!</h5>
                                                    )
                                                )
                                            }
                                        </div>
                                    )
                                }
                                {
                                    showNotInclass && (
                                        <div className="text-center mt-4">
                                            <h5 className="text-danger fw-bold">It appears you are not in the classroom. <br /><br />To mark attendance, please scan the QR code in the classroom.</h5>
                                        </div>
                                    )
                                }
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default QrAttendancePage;